import React, { useState, useEffect } from "react";
import { Field, Input, Button, Label } from "@fluentui/react-components";
import { Add20Filled, Dismiss20Regular, Save20Regular } from "@fluentui/react-icons";
import "../CSS/QueueForm.css";

import { useTranslation } from "react-i18next";
export const WaitTimeSection = (props) => {
  const [newWaitTime, setNewWaitTime] = useState("");
  const { t } = useTranslation();
  // liste réelle de la queue
  const [queueWaitTimes, setQueueWaitTimes] = useState([]);

  // Charger la liste existante depuis la queue
  useEffect(() => {
    if (props.queue && Array.isArray(props.queue.waitTimeIntervals)) {
      setQueueWaitTimes(props.queue.waitTimeIntervals);
    }
  }, [props.queue]);

  // Ajouter un nouvel intervalle à la liste réelle
  const handleAddWaitTime = () => {
    const val = Number(newWaitTime);
    if (val && !queueWaitTimes.includes(val)) {
      const updated = [...queueWaitTimes, val].sort((a, b) => a - b);
      setQueueWaitTimes(updated);
      setNewWaitTime("");

      // notifier le parent
      if (props.onWaitTimesChange) {
        props.onWaitTimesChange(updated);
      }
    }
  };

  // Supprimer un intervalle
  const handleDelete = (time) => {
    const updated = queueWaitTimes.filter((t) => t !== time);
    setQueueWaitTimes(updated);
    if (props.onWaitTimesChange) {
      props.onWaitTimesChange(updated);
    }
  };

  return (
    <>
      {props.queue?.announceEstimatedWaitTime && (
        <>
          <div className="wait-time-row">
            <Input
              size="small"
              type="number"
              placeholder={t("MIN_PLACEHOLDER")}
              min={0}
              value={newWaitTime}
              disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
              onChange={(e) => setNewWaitTime(e.target.value)}
              className="table-header-input-small"
            />

            <Button
              icon={<Save20Regular size="small" />}
              className="btn-add-style"
              appearance="primary"
              size="small"
              disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
              onClick={handleAddWaitTime}
            >
              {t("SAVE")}
            </Button>
          </div>

          <Label weight="semibold">{t("WAIT_TIME_LIST")}</Label>

          {/* Liste réelle venant de la queue */}
          <div className="wait-time-list-values">
            {queueWaitTimes.length > 0 ? (
              queueWaitTimes.map((time, index) => (
                <span key={index} className="wait-time-tag">
                  {time} min{" "}
                  {props.permissions?.canDelete && (
                  <Dismiss20Regular
                    className="delete-waitTimeInterval-btn"
                    style={{
                      marginLeft: "4px",
                      cursor: "pointer",
                      verticalAlign: "middle",
                    }}
                    onClick={() => handleDelete(time)}
                  />
                  )}
                </span>
              ))
            ) : (
              <span style={{ fontStyle: "italic", color: "#888" }}>
                {t("NO_WAIT_TIMES_SET")}
              </span>
            )}
          </div>
        </>
      )}
    </>
  );
};
